import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import type { GameDefinition } from "@spieleparadies/shared";

import { HomePage } from "./pages/HomePage";
import { LobbyPage } from "./pages/LobbyPage";
import { GamePage } from "./pages/GamePage";
import { Layout } from "./components/Layout";
import { SERVER_URL } from "./lib/env";
import { getSocket } from "./lib/socket";
import { installGlobalAudioUnlock } from "./lib/audioUnlock";
import { useGameCatalogStore } from "./state/useGameCatalogStore";

export function App() {
  const setCatalog = useGameCatalogStore((s) => s.setGames);
  const hasGames = useGameCatalogStore((s) => s.games.length > 0);

  // Socket-Singleton sofort erzeugen, damit die persistenten Listener
  // (room:update → Store, etc.) vom ersten Moment an bereit sind.
  // Außerdem global den iOS-Audio-Unlock einklinken – sonst bleiben
  // auf dem iPhone alle Sound-Effekte stumm, weil Phaser nie eine
  // User-Geste zu sehen bekommt.
  useEffect(() => {
    getSocket();
    installGlobalAudioUnlock();
  }, []);

  // Spiele-Katalog beim Start einmal laden – falls noch leer.
  useEffect(() => {
    if (hasGames) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${SERVER_URL}/api/games`);
        const data = (await res.json()) as GameDefinition[];
        if (!cancelled) setCatalog(data);
      } catch {
        // egal – HomePage zeigt einen eigenen Fehler, wenn der Server fehlt
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [hasGames, setCatalog]);

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/lobby/:code" element={<LobbyPage />} />
        <Route path="/spielen/:code" element={<GamePage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </Layout>
  );
}
